<!--
 * @Author: qingqi qingqi@winning.com.cn
 * @Date: 2022-04-29 13:52:44
 * @LastEditors: qingqi qingqi@winning.com.cn
 * @LastEditTime: 2022-09-15 10:44:17
 * @FilePath: \nqc-pc-ui\src\frameworks\views\noZZJG\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="container">
    <img src="@/common/assets/images/none-func.png" alt="people" />
    您尚无任何组织架构，请联系管理员，设置您所在的组织架构。
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  height: 200px;
  margin-top: 100px;
  font-size: 18px;
  color: #b1ada7;
}
</style>
